<template>
  <div>
    <div id="dContentdetalis">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Informations/qbdynamic'}">青博动态</router-link>
      </div>
      <div>
        <div id="sTitle">
          <Title>{{ tableData.title }}</Title>
        </div>
        <div id="contents" v-html="tableData.content">{{ tableData.content }}</div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
    <div id="mdContentdetalis">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Informations/qbdynamic'}">青博动态</router-link>
      </div>
      <div>
        <div>{{ tableData.title }}</div>
        <div id="mcontents" v-html="tableData.contents">{{ tableData.contents }}</div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        clientHeight: '',
        tableData: [],
        infoid: '',
        loading: false,
        title: '',
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("mdContentdetalis").style.display = "block";
        document.getElementById("dContentdetalis").style.display = "none";
      } else {
        document.getElementById("dContentdetalis").style.display = "block";
        document.getElementById("mdContentdetalis").style.display = "none";
      };
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;

        this.loading = true;
        this.infoid = this.$route.query.id;
        let url = this.HOST + '/api/v1/closure/getOne/' + this.$route.query.id + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.tableData = cData.data;
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #dContentdetalis {
    width: 70%;
    margin-right: 15%;
    margin-left: 15%;
    height: 100%;
  }

  #dContentdetalis>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #dContentdetalis>#cNav>span:nth-child(1),
  #dContentdetalis>#cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #dContentdetalis>#cNav>span:nth-child(1):hover,
  #dContentdetials>#cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    font-size: 1.5em;
    font-weight: 800;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 30px;
  }

  /*mobile*/
  #mdContentdetalis {
    margin: auto 20px;
    height: 100%;
  }

  #mdContentdetalis>#mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mdContentdetalis>#mcNav>span:nth-child(1),
  #mdContentdetalis>#mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mdContentdetalis>#mcNav>span:nth-child(1):hover,
  #mdContentdetials>#mcNav>span:nth-child(2):hover {
    color: #mFF9900;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    font-size: 1.5em;
    font-weight: 800;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/informationsDetials/closure.vue